import {
  dropdown,
  multi,
  number,
  OTHER,
  option,
  single,
  text,
  type UsFieldDef,
} from "../us-fields";

export const OBSTETRIC_INDICATIONS = [
  option("vaginal_bleeding", "Vaginal bleeding"),
  option("abdominal_pain", "Abdominal pain"),
  option("pelvic_pain", "Pelvic pain"),
  option("trauma", "Trauma"),
];

export const obstetricFindings = (
  fetalHeartRateLabel: string,
): readonly UsFieldDef[] => [
  single(
    "obstetric.intrauterine_pregnancy",
    "Definitive intrauterine pregnancy",
    [option("present", "Present"), option("absent", "Absent")],
    { normal: "present" },
  ),
  single(
    "obstetric.ectopic_pregnancy",
    "Ectopic pregnancy visualized",
    [
      option("no", "No"),
      option("yes", "Yes", {
        reveals: [
          dropdown("obstetric.ectopic_location", "Ectopic Pregnancy location", [
            option("not_applicable", "N/A"),
            option("left_adnexa", "Left Adnexa"),
            option("left_ovary", "Left Ovary"),
            option("right_adnexa", "Right Adnexa"),
            option("right_ovary", "Right Ovary"),
            option("cervix", "Cervix"),
            option("uterine_wall", "Uterine Wall"),
          ]),
        ],
      }),
    ],
    { normal: "no" },
  ),
  number("obstetric.fetal_heart_rate", fetalHeartRateLabel, "bpm"),
  number("obstetric.gestational_age_weeks", "Gestational age, weeks", "weeks"),
  number("obstetric.gestational_age_days", "Gestational age, days", "days"),
  single(
    "obstetric.pelvic_free_fluid",
    "Free fluid in pelvis",
    [option("absent", "Absent"), option("present", "Present")],
    { normal: "absent" },
  ),
  text("obstetric.other_findings", "Other findings"),
];

export const OBSTETRIC_IMPRESSION = multi(
  "obstetric.impression",
  "Impression",
  [
    option("live_iup", "Live intrauterine present"),
    option(
      "iup_without_heartbeat",
      "Intrauterine pregnancy without notable fetal heartbeat",
    ),
    option("no_definitive_iup", "No definitive intrauterine pregnancy"),
    option("ectopic_pregnancy", "ectopic pregnancy"),
    option("indeterminate", "indeterminate"),
    OTHER,
  ],
);
